import { Button } from '@mui/material'
import { MarkInvoiceAsPaidCommand } from '../../GeneratedClients/FreeBillApi';
import { useNotify, useRefresh, useTranslate } from 'react-admin';
import { apiService } from '../../apiService';
import { useMutation } from "react-query";

interface IProps {
  recordIds: string[]
  userId: string
}

const InvoicePaidButton = ({recordIds, userId}: IProps) => {
  
  const translate = useTranslate()
  const notify = useNotify()
  const refresh = useRefresh()
  const { mutate, isLoading } = useMutation((command: MarkInvoiceAsPaidCommand) => 
    apiService.InvoicesApi.markInvoiceAsPaid({markInvoiceAsPaidCommand: command, id: command.id!}),
    {
      onSuccess: () => {
        notify(translate("resources.invoices.notifications.invoiceStateChanged"))
        refresh()
      },
      onError: (error: any) => {
        notify(error, {type: error})
      }
    }   
  )
  const markInvoiceAsPaid = () => { 
    recordIds.forEach(async recordId => {
      const command: MarkInvoiceAsPaidCommand = {
        id: recordId,
        userId: userId,
      }
      mutate(command)
    })
  }

  return (
    <Button 
      disabled={isLoading} 
      size='small' 
      onClick={markInvoiceAsPaid} 
    >
      {translate(`resources.invoices.paid`)}
    </Button>
  )
}

export default InvoicePaidButton